// FeaturedChecks.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { User, Briefcase, MapPin, DollarSign } from 'lucide-react';

const FeaturedChecks = () => {
  const checks = [
    {
      id: 1,
      icon: User,
      title: "Identity & Background",
      description: "ID inspection, selfie+liveness review (human), guarantor calls, adverse media & PEP/sanctions (manual)."
    },
    {
      id: 2,
      icon: Briefcase,
      title: "Employment & Education",
      description: "Direct confirmation with HR desks and registrars; titles, dates, awards."
    },
    {
      id: 3,
      icon: MapPin,
      title: "Address Verification",
      description: "In-person visit, neighbor/landlord corroboration, photos, geo & time stamps."
    },
    {
      id: 4,
      icon: DollarSign,
      title: "Financial Standing",
      description: "Bank reference letters, proof-of-income, asset evidence (with consent)."
    }
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            Featured verification checks
          </h2>
        </motion.div>

        {/* Checks Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {checks.map((check, index) => {
            const IconComponent = check.icon;
            return (
              <motion.div
                key={check.id}
                className="text-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                {/* Icon */}
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-16 bg-acYellow rounded-full flex items-center justify-center">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
                  {check.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {check.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* CTA */}
        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <Link 
            to="/verification" 
            className="inline-flex items-center bg-acYellow hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
          >
            → Request a Verification
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedChecks;
